// Wishlist.tsx
import React, { useEffect } from 'react';
import './Wishlist.css';
import CourseCard from '@/Components/CourseCard/CourseCard';
import { useLearningsStore } from '@/stores/LearnerStore/LearningsStore';
import { LoadingSpinner, ErrorDisplay } from '@/Components/common';

const Wishlist: React.FC = () => {
  const {
    wishlistCourses,
    loadingWishlist,
    errorWishlist,
    fetchWishlistCourses,
  } = useLearningsStore();

  // Fetch data on mount
  useEffect(() => {
    fetchWishlistCourses();
  }, [fetchWishlistCourses]);

  // Loading state
  if (loadingWishlist) {
    return (
      <LoadingSpinner
        fullScreen
        size="lg"
      />
    );
  }

  // Error state
  if (errorWishlist) {
    return (
      <ErrorDisplay
        fullScreen
        title="Failed to Load Wishlist"
        message={errorWishlist}
        type="error"
        showRetry
        onRetry={fetchWishlistCourses}
      />
    );
  }

  return (
    <div className="wishlist-container">
      <div className="wishlist-header">
        <h1>My Wishlist</h1>
        <p>Save your favorite courses and enroll when you're ready</p>
      </div>
      <div className="wishlist-grid">
        {wishlistCourses?.map((course) => (
          <CourseCard key={course.id} course={course} />
        ))}
      </div>
    </div>
  );
};

export default Wishlist;
